export default {
  budget: 'Budget',
  upTo: 'up to {value}',
  restrictions: 'Restrictions',
  customizations: 'Customizations',
  spendIn: 'Spend in',
  and: 'and',
  predictedSales: 'Predicted {kpi}',
  runningSimulation: 'Running simulation...',
  createdBy: 'Created by',
  on: 'on',
  modelVersion: 'Model version:',
  clone: 'Clone',
  compare: 'Compare',
  edit: 'Edit',
  delete: 'Delete',
  printJsonToConsole: 'Print JSON to console',
  viewMore: 'View more',
  warning: 'Warning',
  deletingSimulation: 'Deleting the simulation:',
  cannotBeUndone: 'This action cannot be undone. Are you sure?',
  cancel: 'Cancel',
  unrestricted: 'Unrestricted',
  moreThan: 'More than',
  lessThan: 'Less than',
  between: 'Between',
  exactly: 'Exactly',
  settings: 'Settings',
  showToExternalUsers: 'Show to external users',
  save: 'Save',
  noPreviewAvailable: 'This model has no combined preview',
  noPreviewReasonOutputs: 'Its results are reported separately for {outputs}, and those KPIs cannot be added up into a single figure or chart.',
  noPreviewReasonGeneric: 'This model reports each KPI separately, so they cannot be added up into a single figure or chart.',
  noPreviewViewMore: 'Click "View more" to review each KPI on its own.',
  kpiWeighting: 'KPI Weighting',
  kpiAutoBalance: 'Auto-Balance',
  timeRestrictions: 'Time restrictions',
  allChannels: 'All Channels',
  fullPeriod: 'Full Period'
}
